import React from 'react'
import ReactDOM from 'react-dom/client'
import './globals.css'
import { Toaster } from 'sonner'
import App from './App'
import './i18n/i18n'
import { HelmetProvider } from 'react-helmet-async'
import { initializeGoogleAnalytics } from './utils/googleAnalytics'

// Initialize Google Analytics
initializeGoogleAnalytics()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <Toaster />
    </HelmetProvider>
  </React.StrictMode>
)
